import React from "react";
import "./style.css";
import Skeleton from "react-loading-skeleton";

const EventCardLoader = () => {
  return (
    <div className="events_card">
      <div className="image_sec_card">
        <Skeleton
          count={1}
          style={{
            "--base-color": "#ccc",
            "--highlight-color": "#f5f5f5",
          }}
        />
        <div className={`card_chip event_chip`}>
          <Skeleton
            width={100}
            height={40}
            count={1}
            style={{
              "--base-color": "#ccc",
              "--highlight-color": "#f5f5f5",
            }}
          />
        </div>
      </div>
      <div className="body_content">
        <Skeleton
          count={1}
          height={120}
          style={{
            "--base-color": "#ccc",
            "--highlight-color": "#f5f5f5",
          }}
        />
      </div>
      <div className="footer_card">
        <Skeleton
          count={1}
          height={10}
          style={{
            "--base-color": "#ccc",
            "--highlight-color": "#f5f5f5",
          }}
        />
      </div>
    </div>
  );
};

export default EventCardLoader;
